export default __webpack_public_path__ + "static/media/12.a57b4e75.svg";